import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { Trash2 } from 'lucide-react';
import { format } from 'date-fns';

const CertificateHistory = ({ certificates, onDelete, onClearAll, onLoad }) => {
  const getTypeName = (type) => {
    const types = {
      'prescription': '🫀 Prescription',
      'sick-leave': '🤒 Sick Leave',
      'fitness': '💪 Fitness',
      'general': '📄 General'
    };
    return types[type] || type;
  };

  return (
    <Card>
      <CardHeader>
        <div className="flex items-center justify-between">
          <div>
            <CardTitle>🗂 Certificate History</CardTitle>
            <CardDescription>
              {certificates.length} Saved locally on this device
            </CardDescription>
          </div>
          {certificates.length > 0 && (
            <Button variant="destructive" size="sm" onClick={onClearAll}>
              🗑 Clear All
            </Button>
          )}
        </div>
      </CardHeader>
      <CardContent>
        {certificates.length === 0 ? (
          <div className="text-center py-8">
            <p className="text-gray-500 mb-2">📂 No saved certificates yet.</p>
            <p className="text-sm text-gray-400">
              Fill in the form above and click <strong>💾 Save Certificate</strong> to get started.
            </p>
          </div>
        ) : (
          <div className="space-y-3 max-h-96 overflow-y-auto">
            {certificates.map((cert) => (
              <div
                key={cert.id}
                className="border rounded-lg p-3 hover:bg-gray-50 transition-colors cursor-pointer"
                onClick={() => onLoad(cert)}
              >
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <div className="flex items-center gap-2 mb-1">
                      <Badge variant="outline">{getTypeName(cert.type)}</Badge>
                      <span className="text-sm text-gray-600">
                        {format(new Date(cert.createdAt), 'dd MMM yyyy, HH:mm')}
                      </span>
                    </div>
                    <p className="font-semibold text-gray-800">{cert.data.patientName || 'Unnamed'}</p>
                    <p className="text-sm text-gray-600">
                      {cert.data.diagnosis === 'Other (Custom)' ? cert.data.customDiagnosis : cert.data.diagnosis}
                    </p>
                  </div>
                  <Button
                    variant="ghost"
                    size="sm"
                    onClick={(e) => {
                      e.stopPropagation();
                      onDelete(cert.id);
                    }}
                    className="text-red-500 hover:text-red-700 hover:bg-red-50"
                  >
                    <Trash2 className="h-4 w-4" />
                  </Button>
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default CertificateHistory;